// src/pages/Sliders.js
import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import SlidersManagement from '../components/sliders/SlidersManagement';

const Sliders = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />
        <div style={{ marginTop: '70px' }}></div>

        <SlidersManagement />
      </div>
    </div>
  );
};

export default Sliders;
